export const APP_NAME = 'Consultorio'
export const APP_VERSION = '0.1.0'

// Values must match the `name` of the seeded roles in the backend (see
// nestjs-proyect-base/src/database/seeds/seed-default-data.ts) — role names
// are editable via Settings > Roles, so if they're renamed there, update these too.
export const ROLES = {
  ADMIN: 'Administrador',
  SECRETARIA: 'Secretaria',
  PROFESSIONAL: 'Profesional',
  PATIENT: 'Paciente',
} as const

export type Role = (typeof ROLES)[keyof typeof ROLES]

export const THEMES = ['light', 'dark', 'corporate-blue', 'emerald', 'purple'] as const
export type Theme = (typeof THEMES)[number]

export const DEFAULT_THEME: Theme = 'light'

export const STORAGE_KEYS = {
  THEME: 'app:theme',
  AUTH_TOKEN: 'app:auth:token',
  AUTH_REFRESH_TOKEN: 'app:auth:refresh-token',
  AUTH_EXPIRES_AT: 'app:auth:expires-at',
  AUTH_USER: 'app:auth:user',
  SIDEBAR_COLLAPSED: 'app:sidebar:collapsed',
} as const

export const THEME_LABELS: Record<Theme, string> = {
  light: 'Light',
  dark: 'Dark',
  'corporate-blue': 'Corporate Blue',
  emerald: 'Emerald',
  purple: 'Purple',
}

export const AUTH_EVENTS = {
  LOGOUT: 'auth:logout',
  TOKEN_REFRESHED: 'auth:token-refreshed',
} as const

export const TOAST_EVENTS = {
  SHOW: 'toast:show',
} as const

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
  },
  USERS: {
    BASE: '/users',
    BY_ID: (id: string) => `/users/${id}`,
    AVAILABLE: '/users/available',
  },
  ROLES: {
    BASE: '/roles',
    BY_ID: (id: string) => `/roles/${id}`,
  },
  PROFESSIONS: {
    BASE: '/professions',
    BY_ID: (id: string) => `/professions/${id}`,
  },
  HOLIDAYS: {
    BASE: '/holidays',
    BY_ID: (id: string) => `/holidays/${id}`,
  },
  PROFESSIONALS: {
    BASE: '/professionals',
    BY_ID: (id: string) => `/professionals/${id}`,
    ME: '/professionals/me',
  },
  SCHEDULES: {
    BASE: '/schedules',
    BY_ID: (id: string) => `/schedules/${id}`,
  },
  PATIENTS: {
    BASE: '/patients',
    BY_ID: (id: string) => `/patients/${id}`,
    ME: '/patients/me',
  },
  APPOINTMENTS: {
    BASE: '/appointments',
    BY_ID: (id: string) => `/appointments/${id}`,
    AVAILABLE_SLOTS: '/appointments/available-slots',
    UPCOMING_AVAILABLE_SLOTS: '/appointments/available-slots/upcoming',
    DASHBOARD_SUMMARY: '/appointments/dashboard-summary',
    CAPACITY: '/appointments/capacity',
    MINE: '/appointments/me',
    CANCEL_MINE: (id: string) => `/appointments/${id}/cancel`,
    RESCHEDULE_MINE: (id: string) => `/appointments/${id}/reschedule`,
  },
  AGENDA_BLOCKS: {
    BASE: '/agenda-blocks',
    BY_ID: (id: string) => `/agenda-blocks/${id}`,
  },
  PROFESSIONAL_LICENSES: {
    BASE: '/professional-licenses',
    BY_ID: (id: string) => `/professional-licenses/${id}`,
  },
  SECURITY_MONITOR: {
    OVERVIEW: '/security-monitor/overview',
    RANKINGS: '/security-monitor/rankings',
    TIMELINE: '/security-monitor/timeline',
    ENDPOINTS: '/security-monitor/endpoints',
    ALERTS: '/security-monitor/alerts',
    BLOCKS: '/security-monitor/blocks',
    UNBLOCK: (id: string) => `/security-monitor/blocks/${id}/unblock`,
  },
  ACTIVITY_MONITOR: {
    HEATMAP: '/activity-monitor/heatmap',
    DAILY: '/activity-monitor/daily',
  },
} as const
